module.exports = "<li data-search-form class=\"input-group__item\">\n</li>\n"